import project1 from "../images/react.png";
import project2 from "../images/org-splash-new.png";
import project3 from "../images/javascript-fullstack.jpg";
import project4 from "../images/mern-stack.jpg";
import project5 from "../images/react-redux.jpg";
import project6 from "../images/react.png";

const projects = [
  {
    name: "Jmytra4u",
    description: `Jmytra4u – Your Friendly Guide to Java and other related skills. At Jmytra4u, we believe in being your mitra (friend) on the journey to mastering Java programming. Whether you’re a beginner or looking to sharpen your skills, you’ll find clear explanations, practical examples, and supportive guidance here.`,
    category: "Personal",
    image: project1,
    skills: ["ReactJS", "Java", "Spring Boot", "Content Writing"],
    duration: "Ongoing",
    role: ["Sr. Developer", "Maintainer", "DevOps"]
  },
  {
    name: "About Me (alokkrsharma)",
    description: `This is a portfolio which describe my journey so far including my Education, Skills and justify my 15+ years of Experience while I worked on different projects of different domains. It will also showcase my achievement through these many years and you know what this is the same site where you are currently!`,
    category: "Personal",
    image: project1,
    skills: ["ReactJS", "Material UI", "JavaScript", "CSS"],
    duration: "2024 – Present",
    role: ["Sr. Developer", "Maintainer", "DevOps"]
  },
  {
    name: "ENI Gold",
    description: `Eni S.p.A. is an Italian multinational energy company headquartered in Rome. It is considered one of the "supermajor" oil companies in the world. 
We, at Accenture, are building a GOLD solution for them to track their contracts, capacities, grid elements, and different reportings, etc..`,
    category: "Professional",
    image: project1,
    skills: ["Java", "Spring Boot", "Microservices", "ReactJS", "Azure", "Agile", "Docker/Kubernetes"],
    duration: "2021 – Present",
    role: ["Associate Manager", "Dev Lead", "DevOps"]
  },
  {
    name: "Intelligent Org. Accelerator",
    description: `Org Accelerator is a product that is built for Accenture Strategy Consultants. This will help analyzing all the activities/processes held within an organization using some historical data, which will be useful for organization re-structuring. It includes n numbers of graphical screens with different types of charts.`,
    category: "Professional",
    image: project2,
    skills: ["Java 8", "ReactJS", "Microservices", "Charts/Visualization", "PostgreSQL"],
    duration: "2018 – 2021",
    role: ["Associate Manager", "Dev Lead", "DevOps", "Sr. Developer"]
  },
  {
    name: "SWINTON",
    description: `Swinton is a solution to maintain the customer-base to UK based insurance organization. With this, the insurance executive can update or analyze the customer details, based on the requirement, whether the customer wants to renew the policies, or he wants some price objections based on some criteria provided!`,
    category: "Professional",
    image: project3,
    skills: ["Java", "J2EE", "Spring", "MySQL", "Agile"],
    duration: "2016 – 2018",
    role: ["Dev Lead", "Sr. Developer"]
  },
  {
    name: "3M",
    description: `3M is a global technology company delivering innovative solutions to life's everyday needs. We, at Accenture, provided them an analytical solution to do past or present analysis of the simulated inventory data.`,
    category: "Professional",
    image: project4,
    skills: ["Java", "Spring Boot", "REST APIs", "SQL", "Analytics"],
    duration: "2016 – 2018",
    role: ["Sr. Developer"]
  },
  {
    name: "Telstra",
    description: `Telstra is Australian Telecomm. & Tech. Company. We provided them an analytical solution to do past or present analysis of the spend and revenue, also to do better forecasting for future using the historical data.`,
    category: "Professional",
    image: project5,
    skills: ["Java", "Spring Boot", "SQL", "Analytics", "Forecasting"],
    duration: "2016 – 2018",
    role: ["Sr. Developer"]
  },
  {
    name: "mWallet (Kotak Mahindra)",
    description: `mobiquity Wallet offers a feature-rich digital wallet for end consumers and a robust and flexible platform for wallet providers and their partners. It combines innovations in payments with cutting edge digital technology.`,
    category: "Professional",
    image: project6,
    skills: ["Java", "Microservices", "REST APIs", "MuleSoft", "Banking Domain"],
    duration: "2015 – 2016",
    role: ["Sr. Developer"]
  },
  {
    name: "MOBIQUITY: DISTRIBUTOR HIER. MANAGEMENT",
    description: `Distributor Hierarchy Management solution to streamline distributor onboarding, relationship management, and transaction flow within telecom/banking ecosystems.`,
    category: "Professional",
    image: project4,
    skills: ["Java", "MuleSoft", "REST APIs", "Core Java"],
    duration: "2015 – 2016",
    role: ["Sr. Developer"]
  },
  {
    name: "MOBIQUITY: UNIFIED WALLET MANAGEMENT",
    description: `Unified Wallet Management for managing multiple wallet providers and ensuring secure transaction flow.`,
    category: "Professional",
    image: project5,
    skills: ["Java", "REST APIs", "Telecom Domain", "Spring"],
    duration: "2015 – 2016",
    role: ["Sr. Developer"]
  },
  {
    name: "DOOR STEP BANKING SOLUTION",
    description: `A doorstep banking solution for financial institutions to provide last-mile services to customers.`,
    category: "Professional",
    image: project6,
    skills: ["Java", "REST APIs", "Banking Domain", "SOAP Web Services"],
    duration: "2012 – 2015",
    role: ["Sr. Developer", "DevOps"]
  },
  {
    name: "FLM & CBR HELPDESK SOLUTION",
    description: `Solution developed for Banks/MSPs to manage First Level Maintenance (FLM) of ATMs plus Cash Balancing and Replenishment (CBR) services.`,
    category: "Professional",
    image: project4,
    skills: ["Java", "JSP/Servlets", "Banking Domain"],
    duration: "2012 – 2015",
    role: ["Sr. Developer", "DevOps"]
  },
  {
    name: "EMTS IVRS + Reporting Solution",
    description: `IVR solution and Reporting Solution for Etisalat (Nigeria) and UBA (United Bank of Africa) with inbound and outbound operations based on Avaya Platform 6.0.`,
    category: "Professional",
    image: project5,
    skills: ["Java", "IVR (Avaya)", "Telecom Domain", "Reporting"],
    duration: "2012 – 2015",
    role: ["Developer"]
  },
  {
    name: "three60 Solution (School ERP Product)",
    description: `A school ERP product used by almost 15 schools all over India. I worked on its financial module (Fees, Payroll and Inventory Management). Apart from that I got exposure of its feedback module for children's study.`,
    category: "Professional",
    image: project6,
    skills: ["Java", "JSP", "Servlets", "MySQL", "ERP Domain"],
    duration: "2011 – 2012",
    role: ["Developer"]
  },
];

export { projects };